/**
 * Revue annuelle : un seul abonnement par commande.
 * Après chaque modification du panier (thème, popups d'upsell, apps), ramène
 * la Revue annuelle à une seule unité : la ligne la plus récente passe à 1,
 * les autres sont retirées, puis une notification prévient le client.
 * Les gabarits Liquid du panier plafonnent déjà la quantité à 1.
 */
(function () {
  const PRODUCT_ID = 9989448040797;
  const NOTICE_KEY = 'revue-annuel-limite-notice';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  const cartMutation = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  let running = false;

  const urlOf = (input) => (input instanceof Request ? input.url : String(input || ''));

  window.fetch = function (input, init) {
    const request = nativeFetch(input, init);
    if (cartMutation.test(urlOf(input))) {
      request.then(() => setTimeout(enforce, 0), () => {});
    }
    return request;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (cartMutation.test(String(url))) {
      this.addEventListener('load', () => setTimeout(enforce, 0));
    }
    return nativeOpen.apply(this, arguments);
  };

  function enforce() {
    if (running) return;
    running = true;
    nativeFetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const lines = cart.items.filter((item) => item.product_id === PRODUCT_ID);
        const total = lines.reduce((sum, item) => sum + item.quantity, 0);
        if (total <= 1) return false;
        const updates = {};
        lines.forEach((item, index) => {
          updates[item.key] = index === 0 ? 1 : 0;
        });
        return nativeFetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        }).then((response) => response.ok);
      })
      .then((changed) => {
        running = false;
        if (changed) refresh();
      })
      .catch(() => {
        running = false;
      });
  }

  function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) {
      try {
        sessionStorage.setItem(NOTICE_KEY, '1');
      } catch (e) {}
      location.reload();
      return;
    }
    showNotice();
    nativeFetch(`${root}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        const parse = (html) => new DOMParser().parseFromString(html || '', 'text/html');
        const drawer = document.querySelector('cart-drawer');
        const fresh = parse(sections['cart-drawer']).querySelector('#CartDrawer');
        const current = document.getElementById('CartDrawer');
        if (drawer && fresh && current) {
          current.innerHTML = fresh.innerHTML;
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        const bubble = document.getElementById('cart-icon-bubble');
        const bubbleSection = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (bubble && bubbleSection) bubble.innerHTML = bubbleSection.innerHTML;
      })
      .catch(() => {});
  }

  function showNotice() {
    const notice = document.createElement('div');
    notice.setAttribute('role', 'status');
    notice.textContent = 'Un seul abonnement annuel à la Revue par commande : nous avons retiré le doublon de votre panier.';
    notice.style.cssText =
      'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;' +
      'max-width:min(92vw,520px);padding:16px 20px;background:#111;color:#fff;' +
      'font-size:16px;line-height:1.4;border-radius:6px;box-shadow:0 6px 24px rgba(0,0,0,.25);';
    document.body.appendChild(notice);
    setTimeout(() => notice.remove(), 7000);
  }

  function init() {
    try {
      if (sessionStorage.getItem(NOTICE_KEY)) {
        sessionStorage.removeItem(NOTICE_KEY);
        showNotice();
      }
    } catch (e) {}
    enforce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
